/* global URL */
import { fieldPropTypes } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'react-emotion';

import { baseInput, getBorderColor } from './Styles';
import Button from '../../components/Buttons/Button';
import { bytesToSize } from '../../helpers/utils';
import CloseIcon from '../Icons/CloseIcon/CloseIcon';
import { POSTER_FIELDS } from '../../constants/eventForm';
import Input from '../../components/Form/Input';
import Style from '../../styles/common';

const VisibleFileInput = styled('div')`
  ${baseInput};
  border-color: ${props => getBorderColor(props)};
  cursor: default;
`;

const UploadButton = styled(Button)`
  font-weight: ${Style.FONT_WEIGHT.REGULAR};
  height: 40px;
  min-width: 0;
  padding: 0 ${Style.SPACING.XS};
`;

const Placeholder = styled('span')`
  color: ${Style.color.PLACEHOLDER};
  margin-left: ${Style.SPACING.S};
`;

const InvisibleFileInput = styled('input')`
  display: none;
`;

const FilePreview = styled('div')`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const FilePreviewContent = styled('div')`
  align-items: center;
  display: flex;
`;

const Details = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: ${Style.SPACING.S};
`;

const Thumbnail = styled('img')`
  max-height: 60px;
  max-width: 60px;
`;

const FileName = styled('span')`
  font-size: ${Style.FONT_SIZE.M};
  font-weight: ${Style.FONT_WEIGHT.MEDIUM};
`;

const FileSize = styled('span')`
  color: ${Style.color.SECONDARY_TEXT};
  font-size: ${Style.FONT_SIZE.S};
`;

class FileInput extends React.Component {
  static propTypes = {
    ...fieldPropTypes,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
  };

  static defaultProps = {
    label: '',
    placeholder: '',
    type: 'text',
  };

  render() {
    return (
      <Input {...this.props}>
        <VisibleFileInput
          onClick={!this.value ? this.onClick : undefined}
          placeholder={this.props.placeholder}
          type="file"
        >
          {this.inputContent}
        </VisibleFileInput>
        <InvisibleFileInput
          onChange={this.onChange}
          ref={this.setInvisibleFileInputRef}
          type="file"
        />
      </Input>
    );
  }

  get inputContent() {
    const hasImage = this.file || this.url;
    return hasImage ? this.inputContentPreview : FileInput.inputContentSelect;
  }

  static get inputContentSelect() {
    return (
      <div>
        <UploadButton>Select poster</UploadButton>
        <Placeholder>No file selected</Placeholder>
      </div>
    );
  }

  get inputContentPreview() {
    return (
      <FilePreview>
        <FilePreviewContent>
          <Thumbnail src={this.thumbnailUrl} />
          <Details>
            <FileName>{this.value.name}</FileName>
            <FileSize>{bytesToSize(this.value.size)}</FileSize>
          </Details>
        </FilePreviewContent>
        <CloseIcon onClick={this.clearInput} />
      </FilePreview>
    );
  }

  get thumbnailUrl() {
    return this.file ? URL.createObjectURL(this.file) : this.url;
  }

  get value() {
    return this.props.input.value;
  }

  get file() {
    return this.value[POSTER_FIELDS.FILE];
  }

  get url() {
    return this.value[POSTER_FIELDS.URL];
  }

  setInvisibleFileInputRef = element => this.invisibleFileInput = element;

  onChange = event => {
    const file = event.target.files[0];
    const value = file ? {
      [POSTER_FIELDS.FILE]: file,
      [POSTER_FIELDS.NAME]: file.name,
      [POSTER_FIELDS.SIZE]: file.size,
    } : null;
    this.props.input.onChange(value);
  };

  onClick = () => {
    ReactDOM.findDOMNode(this.invisibleFileInput).click();
  };

  clearInput = () => {
    this.props.input.onChange(null);
    this.props.input.onBlur();
  };
}

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/Form/FileInput.js